import React from 'react';
import { IconCardSupplementary } from '@scotia/canvas-react';
import { AddAccountIcon } from '../../../../../assets/AddAccountIcon';
import { AddCardIcon } from '../../../../../assets/AddCardIcon';
import { AddCreditIcon } from '../../../../../assets/AddCreditIcon';
import { AddInvestmentIcon } from '../../../../../assets/AddInvestmentIcon';

export const renderIcon = id => {
  switch (id) {
    case 'ACCOUNTS':
      return <AddAccountIcon />;
    case 'CARDS':
      return <AddCardIcon />;
    case 'CREDITS':
      return <AddCreditIcon />;
    case 'INVESTMENTS':
      return <AddInvestmentIcon />;
    default:
      return <IconCardSupplementary size={24} />;
  }
};
